




























































import { Component, Vue, Inject } from "vue-property-decorator";
import Footer from "../components/Footer.vue";
import TenantSwitch from "../components/tenant-switch.vue";
import LanguageSwitch from "../components/language-switch.vue";
import iView from "iview";
import AbpBase from "../lib/abpbase";
import ajax from "../lib/ajax";
import Util from "../lib/util";
import appconst from "../lib/appconst";
import { setTimeout } from "timers";
import systemInfo from "../lib/infoConfig";

const appid = "wx003757ee144cae06";
const agentid = "1000052";
const state = 2; // 采联租户
const redirect_uri = encodeURIComponent("http://qy.chinapsp.cn:8884");

@Component({
  components: { Footer, TenantSwitch, LanguageSwitch }
})
export default class Login extends AbpBase {
  loginModel = {
    userNameOrEmailAddress: "",
    password: "",
    rememberMe: true
  };
  showChangeTenant: boolean = false;
  wechatLogin: boolean = false;
  systemInfo = systemInfo;
  async login() {
    (this.$refs.loginform as any).validate(async (valid: boolean) => {
      if (valid) {
        this.$Message.loading({
          content: "登录中",
          duration: 0
        });
        await this.$store.dispatch({
          type: "app/login",
          data: this.loginModel
        });
        sessionStorage.setItem(
          "rememberMe",
          this.loginModel.rememberMe ? "1" : "0"
        );
        location.reload();
      }
    });
  }
  get tenant() {
    return this.$store.state.session.tenant;
  }
  rules = {
    userNameOrEmailAddress: [
      { required: true, message: "用户名不能为空", trigger: "blur" }
    ],
    password: [{ required: true, message: "密码不能为空", trigger: "blur" }]
  };
  mounted() {
    // 添加键盘快捷键
    window.addEventListener("keydown", e => {
      if (e.keyCode === 13) {
        this.login()
      }
    });
  }
  created() {
    let href = window.location.href;
    if (href.indexOf("?qyLogin") !== -1) {
      this.spinShow("正在登录请稍候..")

      // 微信登录回调根据state确定租户
      const loginUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=${state}#wechat_redirect`
      window.location.href = loginUrl
    }
    // 设置租户采联
    Util.abp.multiTenancy.setTenantIdCookie(state)

    this.autoLogin(href)
    window.addEventListener("hashchange", e => {
      this.autoLogin(e.newURL)
    })
  }
  // 加载过程
  spinShow(text: String) {
    (this as any).$Spin.show({
      render: (h: any) => {
        return h("div", [
          h("Icon", {
            class: "demo-spin-icon-load",
            props: {
              type: "ios-loading",
              size: 18
            }
          }),
          h("div", text)
        ]);
      }
    });
  }
  async autoLogin(href: String) {
    if (href.indexOf("?code") !== -1) {
      this.spinShow("正在登录请稍候..");
      const findex = href.indexOf("?code");
      const lindex = href.indexOf("&state");
      let klindex = href.indexOf("#/");
      if (href.indexOf("&appid")) {
        klindex = href.indexOf("&appid");
      }
      const code = href.slice(findex + 6, lindex);
      const key = href.slice(lindex + 7, klindex);
      if (key.indexOf('test') !==-1) {
        // const data = {
        //   authProvider: "Wechat",
        //   providerAccessCode: code
        // };
        // Util.abp.multiTenancy.setTenantIdCookie(key);
        // let url = 'http://192.168.166.168:8882/api/TokenAuth/ExternalAuthenticate'
        // let rep = await ajax.post(url, data);
        // var tokenExpireDate = new Date(
        //   new Date().getTime() + 1000 * rep.data.result.expireInSeconds
        // );
        // Util.abp.auth.setToken(rep.data.result.accessToken, tokenExpireDate);
        // Util.abp.utils.setCookieValue(
        //   appconst.authorization.encrptedAuthTokenName,
        //   rep.data.result.encryptedAccessToken,
        //   tokenExpireDate,
        //   Util.abp.appPath
        // );
        // sessionStorage.setItem("rememberMe", "1");
        // window.location.href = 'http://localhost:8080/'
        return
      }
      const data = {
        authProvider: "Wechat",
        providerAccessCode: code
      };
      Util.abp.multiTenancy.setTenantIdCookie(key);
      try {
        let rep = await ajax.post("/api/TokenAuth/ExternalAuthenticate", data);
        var tokenExpireDate = new Date(
          new Date().getTime() + 1000 * rep.data.result.expireInSeconds
        );
        Util.abp.auth.setToken(rep.data.result.accessToken, tokenExpireDate);
        Util.abp.utils.setCookieValue(
          appconst.authorization.encrptedAuthTokenName,
          rep.data.result.encryptedAccessToken,
          tokenExpireDate,
          Util.abp.appPath
        );
        sessionStorage.setItem("rememberMe", "1");
        window.location.href = 'http://qy.chinapsp.cn:8884'
      } catch (err) {
        console.error(err)
        // 重新登陆
        // alert(JSON.stringify({num: 2, err}))
        window.location.href = 'http://qy.chinapsp.cn:8884/?qyLogin'
      }
    }
  }
  changeWechatLogin() {
    this.wechatLogin = true;
    setTimeout(() => {
      (window as any).WwLogin({
        id: "wx_reg",
        appid: appid,
        agentid: agentid,
        redirect_uri: redirect_uri,
        state: state
      });
    }, 0);
  }
  goSignIn() {
    this.$router.push({ name: "signin" });
  }
  goForgetPwd() {
    this.$router.push({ name: "forgetPwd" });
  }
}
